
import { t } from '@/plugins/i18n'
import { useRtfix } from '@/store'
import { ElMessageBox } from 'element-plus'
export const showModal = (router:any) => {
  let timer:any = null
  const error = {
    msg: [
      t('您的余额不足，请充值后再次支付'),
      t('5s后跳转充值页面'),
      t('去充值'),
      t('')
    ],
    ok: () =>
      useRtfix('CustomerFund')
  }
  const { msg, ok } = error

  ElMessageBox.confirm(
    `
          <div class="text-ct">${msg[0]}</div>
          <div class="text-ct">${msg[1]}</div>
          `,
    msg[3],
    {
      dangerouslyUseHTMLString: true,
      confirmButtonText: msg[2],
      cancelButtonText: t('回到首页'),
      distinguishCancelAndClose: true,
      customClass: 'stupid-el',
      type: 'error'
    }
  )
    .then(() => {
      clearTimeout(timer)
      router.push(ok())
    })
    .catch((action) => {
      if (action === 'cancel') {
        clearTimeout(timer)
        location.href = '/'
      }
    })
  // 5s后跳转订单详情
  timer = setTimeout(() => {
    const a: any = document.querySelector('.stupid-el')
    if (a) {
      const m = a.parentNode.parentNode
      m.parentNode.removeChild(m)
      router.push(ok())
    }
  }, 5000)
}
